import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useMemoriserVue } from "@/lib/retourVue";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import VillePage from "@/pages/VillePage";
import LoveFeed from "@/pages/LoveFeed";
import LoveProfilEdit from "@/pages/LoveProfilEdit";
import Register from "@/pages/Register";
import Subscription from "@/pages/Subscription";
import Annonces from "@/pages/Annonces";
import AnnoncesRedirection from "@/pages/AnnoncesRedirection";
import Messages from "@/pages/Messages";
import Connexion from "@/pages/Connexion";
import VerificationOtp from "@/pages/VerificationOtp";
import TableauDeBord from "@/pages/TableauDeBord";
import Admin from "@/pages/Admin";
import FodindinLoveRegister from "@/pages/FodindinLoveRegister";
import FodindinLoveStep2 from "@/pages/FodindinLoveStep2";
import Legal from "@/pages/Legal";
import ChoixCategorie from "@/pages/ChoixCategorie";
import ConsulterAnnonces from "@/pages/ConsulterAnnonces";
import AirBengue from "@/pages/AirBengue";
import AnnoncePartagee from "@/pages/AnnoncePartagee";
import AnnonceDetail from "@/pages/AnnonceDetail";
import DeposerAirBengue from "@/pages/DeposerAirBengue";
import ContactsPremium from "@/pages/ContactsPremium";
import ResultatPaiement from "@/pages/ResultatPaiement";
import RepriseePaiement from "@/pages/RepriseePaiement";
import { AgeVerificationPopup } from "@/components/AgeVerificationPopup";
import { initGA4 } from "@/lib/ga4";
import { initAntiClonage } from "@/lib/fingerprinting";

/** Garde en mémoire la dernière vue consultée pour pouvoir y revenir après un paiement. */
const MemoriseVue = () => {
  useMemoriserVue();
  return null;
};

function App() {
  useEffect(() => {
    initGA4();
    // Bastion : anti-clonage actif UNIQUEMENT sur le site live (voir lib/fingerprinting.js).
    const minuteurIntegrite =
      process.env.NODE_ENV === "production"
        ? setTimeout(() => initAntiClonage(), 2500)
        : null;
    if (localStorage.getItem("fodindin_theme") === "dark") {
      document.documentElement.classList.add("dark");
    }
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => { if (minuteurIntegrite) clearTimeout(minuteurIntegrite); lenis.destroy(); };
  }, []);

  return (
    <div className="App grain">
      <AgeVerificationPopup />
      <BrowserRouter>
        <MemoriseVue />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categorie/:categoryId" element={<CategoryPage />} />
          <Route path="/categorie/:categoryId/choix" element={<ChoixCategorie />} />
          <Route path="/categorie/:categoryId/annonces" element={<ConsulterAnnonces />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/inscription/love" element={<FodindinLoveRegister />} />
          <Route path="/inscription/love/etape2" element={<FodindinLoveStep2 />} />
          <Route path="/conditions-generales" element={<Legal />} />
          <Route path="/confidentialite" element={<Legal />} />
          <Route path="/abonnement" element={<Subscription />} />
          <Route path="/annonces" element={<Annonces />} />
          <Route path="/air-bengue" element={<AirBengue />} />
          <Route path="/annonce/:annonceId" element={<AnnoncePartagee />} />
          <Route path="/annonces/:annonceId" element={<AnnonceDetail />} />
          <Route path="/ville/:villeSlug" element={<VillePage />} />
          <Route path="/love" element={<LoveFeed />} />
          <Route path="/love/mon-profil" element={<LoveProfilEdit />} />
          <Route path="/air-bengue/deposer" element={<DeposerAirBengue />} />
          <Route path="/annonces-consulter" element={<AnnoncesRedirection />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/verification" element={<VerificationOtp />} />
          <Route path="/compte" element={<TableauDeBord />} />
          <Route path="/contacts" element={<ContactsPremium />} />
          <Route path="/paiement/retour" element={<ResultatPaiement />} />
          <Route path="/paiement/reprise/:transactionId" element={<RepriseePaiement />} />          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
